<template>
    <div>
        <div class="pt-2 mx-8">
            <div class="p-4 rounded-xl bg-base-100 mb-2" v-if="detailData.running && detailData.running.length > 0">
                <div class=" text-xl font-medium">
                    <div class="flex items-center">
                        <div>进行中</div>
                        <div class="badge badge-error gap-2 ml-2">
                            {{ detailData.running_count }}
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>创建时间</th>
                                <th>原因</th>
                                <th class="w-32">操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.running" :key="'running' + index">
                                <th>{{ (pagination.running.current - 1) * pagination.running.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>{{ item.created_at }}</td>
                                <td>{{ item.reason }}</td>
                                <td>
                                    <button class="btn btn-xs btn-outline btn-error" @click="handleStopDetail(item.id)">停止</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.running && detailData.running.length > pagination.running.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.running.current === 1}"
                                    @click="handlePageChange('running', pagination.running.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.running.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.running || pagination.running.current >= Math.ceil(detailData.running.length / pagination.running.pageSize)}"
                                    @click="handlePageChange('running', pagination.running.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-base-100 mb-2 p-4 rounded-xl" v-if="detailData.miss_tag && detailData.miss_tag.length > 0">
                <div class="text-xl font-medium flex justify-between">
                    <div class="flex items-center">
                        <div>未匹配</div>
                        <div class="badge badge-error gap-2 ml-2">
                            {{ detailData.miss_tag_count }}
                        </div>
                    </div>
                    <button class="btn btn-xs btn-outline" @click="handleRedirectHome('未匹配')">跳转操作台</button>
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>原因</th>
                                <th class="w-32">操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.missTag" :key="'miss_tag' + index">
                                <th>{{ (pagination.missTag.current - 1) * pagination.missTag.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>{{ item.reason }}</td>
                                <td>
                                    <a class="link link-secondary" v-if="item.candidate_list && item.candidate_list.length >0"
                                       @click="handleBeixuan(item)">候选
                                    </a>
                                    <a class="link link-primary" v-else
                                       @click="handleEditDetail(item)">编辑
                                    </a>
                                    <a class="link link-success"
                                       @click="handleFinish(item)">完成
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.miss_tag && detailData.miss_tag.length > pagination.missTag.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.missTag.current === 1}"
                                    @click="handlePageChange('missTag', pagination.missTag.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.missTag.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.miss_tag || pagination.missTag.current >= Math.ceil(detailData.miss_tag.length / pagination.missTag.pageSize)}"
                                    @click="handlePageChange('missTag', pagination.missTag.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-base-100 mb-2 p-4 rounded-xl" v-if="detailData.candidate && detailData.candidate.length > 0">
                <div class="text-xl font-medium flex justify-between">
                    <div class="flex items-center">
                        <div>待候选</div>
                        <div class="badge badge-error gap-2 ml-2">
                            {{ detailData.candidate_count }}
                        </div>
                    </div>
                    <button class="btn btn-xs btn-outline" @click="handleBatchAiCandidate">AI候选</button>
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>原因</th>
                                <th class="w-32">操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.candidate" :key="'candidate' + index">
                                <th>{{ (pagination.candidate.current - 1) * pagination.candidate.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>{{ item.reason }}</td>
                                <td>
                                    <a class="link link-secondary" v-if="item.candidate_list && item.candidate_list.length >0"
                                       @click="handleBeixuan(item)">候选
                                    </a>
                                    <a class="link link-primary" v-if="item.candidate_list && item.candidate_list.length >0"
                                       @click="handleAiCandidate(item)">AI候选
                                    </a>
                                    <a class="link link-primary" v-else
                                       @click="handleEditDetail(item)">编辑
                                    </a>
                                    <a class="link link-success"
                                       @click="handleFinish(item)">完成
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.candidate && detailData.candidate.length > pagination.candidate.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.candidate.current === 1}"
                                    @click="handlePageChange('candidate', pagination.candidate.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.candidate.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.candidate || pagination.candidate.current >= Math.ceil(detailData.candidate.length / pagination.candidate.pageSize)}"
                                    @click="handlePageChange('candidate', pagination.candidate.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 rounded-xl bg-base-100 mb-2" v-if="detailData.miss_artist && detailData.miss_artist.length > 0">
                <div class=" text-xl font-medium">
                    <div class="flex items-center">
                        <div>缺失艺术家</div>
                        <div class="badge badge-error gap-2 ml-2">
                            {{ detailData.miss_artist_count }}
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>标题</th>
                                <th>艺术家</th>
                                <th>专辑</th>
                                <th>原因</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- miss artist -->
                            <tr v-for="(item, index) in paginatedData.missArtist" :key="'miss_artist' + index">
                                <th>{{ (pagination.missArtist.current - 1) * pagination.missArtist.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>{{ item.title }}</td>
                                <td>{{ item.artist }}</td>
                                <td>{{ item.album }}</td>
                                <td>{{ item.reason }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.miss_artist && detailData.miss_artist.length > pagination.missArtist.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.missArtist.current === 1}"
                                    @click="handlePageChange('missArtist', pagination.missArtist.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.missArtist.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.miss_artist || pagination.missArtist.current >= Math.ceil(detailData.miss_artist.length / pagination.missArtist.pageSize)}"
                                    @click="handlePageChange('missArtist', pagination.missArtist.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 rounded-xl bg-base-100 mb-2" v-if="detailData.miss_album && detailData.miss_album.length > 0">
                <div class=" text-xl font-medium flex justify-between">
                    <div class="flex items-center">
                        <div>缺失专辑</div>
                        <div class="badge badge-error gap-2 ml-2">
                            {{ detailData.miss_album_count }}
                        </div>
                    </div>
                    <!-- <button class="btn btn-xs btn-outline" @click="handleRedirectHome('缺失专辑')">跳转操作台</button> -->
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>标题</th>
                                <th>艺术家</th>
                                <th>专辑</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in paginatedData.missAlbum" :key="'miss_album' + index">
                                <th>{{ (pagination.missAlbum.current - 1) * pagination.missAlbum.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>{{ item.title }}</td>
                                <td>{{ item.artist }}</td>
                                <td>{{ item.album }}</td>
                                <td>
                                    <a class="link link-primary"
                                       @click="handleEditDetail(item)">编辑
                                    </a>
                                    <a class="link link-success"
                                       @click="handleFinish(item)">完成
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.miss_album && detailData.miss_album.length > pagination.missAlbum.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.missAlbum.current === 1}"
                                    @click="handlePageChange('missAlbum', pagination.missAlbum.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.missAlbum.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.miss_album || pagination.missAlbum.current >= Math.ceil(detailData.miss_album.length / pagination.missAlbum.pageSize)}"
                                    @click="handlePageChange('missAlbum', pagination.missAlbum.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 rounded-xl bg-base-100 mb-2" v-if="detailData.miss_artist_album && detailData.miss_artist_album.length > 0">
                <div class=" text-xl font-medium">
                    <div class="flex items-center">
                        <div>缺失艺术家和专辑</div>
                        <div class="badge badge-error gap-2 ml-2">
                            {{ detailData.miss_artist_album_count }}
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- miss artist album -->
                            <tr v-for="(item, index) in paginatedData.missArtistAlbum" :key="'miss_artist_album' + index">
                                <th>{{ (pagination.missArtistAlbum.current - 1) * pagination.missArtistAlbum.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>
                                    <a class="link link-primary"
                                       @click="handleEditDetail(item)">编辑
                                    </a>
                                    <a class="link link-success"
                                       @click="handleFinish(item)">完成
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.miss_artist_album && detailData.miss_artist_album.length > pagination.missArtistAlbum.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.missArtistAlbum.current === 1}"
                                    @click="handlePageChange('missArtistAlbum', pagination.missArtistAlbum.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.missArtistAlbum.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.miss_artist_album || pagination.missArtistAlbum.current >= Math.ceil(detailData.miss_artist_album.length / pagination.missArtistAlbum.pageSize)}"
                                    @click="handlePageChange('missArtistAlbum', pagination.missArtistAlbum.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 rounded-xl bg-base-100 mb-2" v-if="detailData.fail && detailData.fail.length > 0">
                <div class="text-xl font-medium flex justify-between">
                    <div class="flex items-center">
                        <div>异常失败</div>
                        <div class="badge badge-error gap-2 ml-2">
                            {{ detailData.fail_count }}
                        </div>
                    </div>
                    <button class="btn btn-xs btn-outline btn-error hover:!text-white" @click="handleDeleteAllFail">全部删除</button>
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>标题</th>
                                <th>原因</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.fail" :key="'fail' + index">
                                <th>{{ (pagination.fail.current - 1) * pagination.fail.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>{{ item.title }}</td>
                                <td>{{ item.reason }}</td>
                                <td>
                                    <a class="link link-secondary" v-if="item.candidate_list && item.candidate_list.length >0"
                                       @click="handleBeixuan(item)">候选</a>
                                       <a class="link link-primary"
                                       @click="handleEditDetail(item)">编辑
                                    </a>
                                    <a class="link link-success"
                                       @click="handleFinish(item)">完成
                                    </a>
                                    <a class="link"
                                       @click="handleDelete(item)">删除文件</a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.fail && detailData.fail.length > pagination.fail.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.fail.current === 1}"
                                    @click="handlePageChange('fail', pagination.fail.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.fail.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.fail || pagination.fail.current >= Math.ceil(detailData.fail.length / pagination.fail.pageSize)}"
                                    @click="handlePageChange('fail', pagination.fail.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 rounded-xl bg-base-100 mb-2" v-if="detailData.mode_success && detailData.mode_success.length > 0">
                <div class=" text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ detailData.mode_name }}</div>
                        <div class="badge badge-success gap-2 ml-2">
                            {{ detailData.mode_success_count }}
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>标题</th>
                                <th>艺术家</th>
                                <th>专辑</th>
                                <th>原因</th>
                                <th>相似度</th>
                                <th class="w-16">操作</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.modeSuccess" :key="'mode' + index">
                                <th>{{ (pagination.modeSuccess.current - 1) * pagination.modeSuccess.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>
                                    <div class="flex flex-col">
                                        {{ item.title }}
                                        <span class="text-xs text-gray-500 line-through">
                                            {{ item.extra.raw_title }}
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div class="flex flex-col">
                                        {{ item.artist }}
                                    <span class="text-xs text-gray-500 line-through">
                                            {{ item.extra.raw_artist }}
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div class="flex flex-col">
                                        {{ item.album }}
                                    <span class="text-xs text-gray-500 line-through">
                                        {{ item.extra.raw_album }}
                                        </span>
                                    </div>
                                </td>
                                <td>{{ item.reason }}</td>
                                <td>{{ (item.similar/3).toFixed(2) }}</td>
                                <td>
                                    <a class="link link-secondary" v-if="item.candidate_list && item.candidate_list.length >0"
                                       @click="handleBeixuan(item)">复核</a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.mode_success && detailData.mode_success.length > pagination.modeSuccess.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.modeSuccess.current === 1}"
                                    @click="handlePageChange('modeSuccess', pagination.modeSuccess.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.modeSuccess.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.mode_success || pagination.modeSuccess.current >= Math.ceil(detailData.mode_success.length / pagination.modeSuccess.pageSize)}"
                                    @click="handlePageChange('modeSuccess', pagination.modeSuccess.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 rounded-xl bg-base-100 mb-2" v-if="detailData.success && detailData.success.length > 0">
                <div class=" text-xl font-medium">
                    <div class="flex items-center">
                        <div>完全匹配</div>
                        <div class="badge badge-success gap-2 ml-2">
                            {{ detailData.success_count }}
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>标题</th>
                                <th>艺术家</th>
                                <th>专辑</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.success" :key="'succ' + index">
                                <th>{{ (pagination.success.current - 1) * pagination.success.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>{{ item.title }}</td>
                                <td>{{ item.artist }}</td>
                                <td>{{ item.album }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.success && detailData.success.length > pagination.success.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.success.current === 1}"
                                    @click="handlePageChange('success', pagination.success.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.success.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.success || pagination.success.current >= Math.ceil(detailData.success.length / pagination.success.pageSize)}"
                                    @click="handlePageChange('success', pagination.success.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 rounded-xl bg-base-100 mb-2" v-if="detailData.skip && detailData.skip.length > 0">
                <div class=" text-xl font-medium">
                    <div class="flex items-center">
                        <div>跳过匹配</div>
                        <div class="badge badge-neutral gap-2 ml-2">
                            {{ detailData.skip_count }}
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>文件名</th>
                                <th>原因</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.skip" :key="'skip' + index">
                                <th>{{ (pagination.skip.current - 1) * pagination.skip.pageSize + index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>{{ item.reason | '已存在标签,无需再刮削' }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.skip && detailData.skip.length > pagination.skip.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.skip.current === 1}"
                                    @click="handlePageChange('skip', pagination.skip.current - 1)">«</button>
                                <button class="join-item btn btn-sm">第 {{ pagination.skip.current }} 页</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.skip || pagination.skip.current >= Math.ceil(detailData.skip.length / pagination.skip.pageSize)}"
                                    @click="handlePageChange('skip', pagination.skip.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'autoEditLogDetail',
    props: {
        detailData: { type: Object, required: true }
    },
    data() {
        return {
            pagination: {
                running: { current: 1, pageSize: 10 },
                missTag: { current: 1, pageSize: 10 },
                missArtist: { current: 1, pageSize: 10 },
                missAlbum: { current: 1, pageSize: 10 },
                missArtistAlbum: { current: 1, pageSize: 10 },
                fail: { current: 1, pageSize: 10 },
                modeSuccess: { current: 1, pageSize: 10 },
                success: { current: 1, pageSize: 10 },
                skip: { current: 1, pageSize: 10 },
                candidate: { current: 1, pageSize: 10 }
            },
        }
    },
    computed: {
        paginatedData() {
            return {
                running: this.getPaginatedData(this.detailData.running || [], this.pagination.running),
                missTag: this.getPaginatedData(this.detailData.miss_tag || [], this.pagination.missTag),
                candidate: this.getPaginatedData(this.detailData.candidate || [], this.pagination.candidate),
                missArtist: this.getPaginatedData(this.detailData.miss_artist || [], this.pagination.missArtist),
                missAlbum: this.getPaginatedData(this.detailData.miss_album || [], this.pagination.missAlbum),
                missArtistAlbum: this.getPaginatedData(this.detailData.miss_artist_album || [], this.pagination.missArtistAlbum),
                fail: this.getPaginatedData(this.detailData.fail || [], this.pagination.fail),
                modeSuccess: this.getPaginatedData(this.detailData.mode_success || [], this.pagination.modeSuccess),
                success: this.getPaginatedData(this.detailData.success || [], this.pagination.success),
                skip: this.getPaginatedData(this.detailData.skip || [], this.pagination.skip)
            }
        }
    },
    methods: {
        getPaginatedData(data, pagination) {
            const start = (pagination.current - 1) * pagination.pageSize;
            const end = start + pagination.pageSize;
            return data.slice(start, end);
        },
        handlePageChange(type, page) {
            this.pagination[type].current = page;
        },
        handleStopDetail(id) {
            this.$emit('stop-detail', id);
        },
        handleBeixuan(item) {
            this.$emit('beixuan', item);
        },
        handleAiCandidate(item) {
            this.$emit('ai-candidate', item);
        },
        handleEditDetail(item) {
            this.$emit('edit-detail', item);
        },
        handleFinish(item) {
            this.$emit('finish', item);
        },
        handleDelete(item) {
            this.$emit('delete', item);
        },
        handleDeleteAllFail() {
            this.$emit('delete-all-fail');
        },
        handleBatchAiCandidate() {
            this.$emit('batch-ai-candidate');
        },
        handleRedirectHome(status) {
            // 构建虚拟路径：/virtual/audit/#{id} {action}-{created_at}/未匹配
            const auditLogId = this.detailData.id;
            const action = this.detailData.action || this.detailData.name || '自动刮削';
            const createdAt = this.detailData.created_at || '';

            // 格式化路径，类似：/virtual/audit/#59 自动刮削-2025-11-19 14:24:08/未匹配
            // const virtualPath = `/app/virtual/audit/#${auditLogId} ${action}-${createdAt}/未匹配`;
            const virtualPath = `/Users/macbookair/Music/my_music/music/virtual/audit/#${auditLogId} ${action}-${createdAt}/${status}`;

            // 跳转到操作台（home 页面），并传递路径参数
            this.$router.push({
                name: 'home',
                query: {
                    path: virtualPath
                }
            });
        }
    }
}
</script>

<style scoped>

</style>
